import { Directive, EventEmitter, Input, Output } from '@angular/core';

export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

export interface SortEvent {
    column: string;   
}

@Directive({
    selector: 'th[sortable]',
    host: {
        '[class.asc]': 'direction === "asc"',
        '[class.desc]': 'direction === "desc"',
        '(click)': 'rotate()'
    },
    standalone: false
})
export class NgbdSortableHeaderDirective {

    @Input() sortable: string;
    @Input() data: any[];
    @Input() direction: SortDirection = '';
    @Output() sort = new EventEmitter<SortEvent>();

    rotate() {
        this.direction = rotate[this.direction];
        this.sortData();
        this.sort.emit({ column: this.sortable });        
    }

    private compare(a, b) {
        // equal items sort equally
        if (a === b) {
            return 0;
        }
        // nulls sort after anything else
        else if (a === null || a === '') {
            return 1;
        }
        else if (b === null || b === '') {
            return -1;
        }
        // otherwise - lowest sorts first
        else {
            return a < b ? -1 : 1;
        }     
    }

    private sortData(): void {
        if (this.direction != '') {
            this.data.sort((a, b) => {
                const res = this.compare(a[this.sortable], b[this.sortable]);
                return this.direction === 'asc' ? res : -res;
            });
        }       
    }
}
